export default __webpack_public_path__ + "static/media/project2.bf27f23c.jpg";